import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BlueBirdTheme } from "@kitbird/core";
import KitSidebar from "./Sidebar.style";
import logo from "../../assets/icons/cash_journal_logo.svg";
import { ReactComponent as TransactionIcon } from "../../assets/icons/credit_card.svg";
import { ReactComponent as HomeIcon } from "../../assets/icons/home_icon.svg";
import useAuth from "../Authentication/useAuth";

const { gray } = BlueBirdTheme.colors;

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { rbacInfo } = useAuth();
  const pathName = location.pathname.split("/")[1] || "";
  const [currentLocation, setCurrentLocation] = useState(pathName);
  useEffect(() => {
    setCurrentLocation(location.pathname.slice(1) || "");
  }, [location]);

  const iconByMenuName = (menuName: string) => {
    let MenuIcon = <></>;
    if (menuName === "Transaksi") MenuIcon = <TransactionIcon color={gray.bodyText} />;
    else if (menuName === "Master data") MenuIcon = <HomeIcon color={gray.bodyText} />;
    else MenuIcon = <HomeIcon color={gray.bodyText} />;
    return MenuIcon;
  };

  const menu = rbacInfo.filter((parent) => parent.has_access && parent.type_id === 1)
    .map((parent) => ({
      id: parent.menu_id,
      path: parent.menu_url,
      title: parent.menu_name,
      icon: iconByMenuName(parent.menu_name),
      submenu: parent.sub_menus?.filter((sub) => sub.has_access && sub.type_id === 1)
        .map((sub) => ({
          id: sub.menu_id,
          path: sub.menu_url,
          title: sub.menu_name,
        })),
    }));

  return (
    <KitSidebar
      logo={<img src={logo} className="cash_journal_logo" alt="cash_journal_logo" width={52} />}
      menu={menu}
      onNavigate={(path: string) => navigate(path)}
      pathname={`/${currentLocation}`}
      title="SIMPLE"
      isResizeSidebar
    />
  );
};

export default Sidebar;
